import { GET_CAPTURE_DATA } from '../types'

const initialState = {
  captureData: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_CAPTURE_DATA: return {
      ...state,
      captureData: action.payload
    }
    default: return { ...state }
  }
}
